export default __webpack_public_path__ + "static/media/lifeleech1.22b152d4.png";